/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "VerifyVerificationEmailRequest": {
                "fields": {
                  "verificationCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "VerifyVerificationEmailResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "status": {
                    "type": ".squareup.corporate_card.service.VerifyVerificationEmailResponse.Status",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "INVALID": 0,
                      "SUCCESS": 1,
                      "INVALID_VERIFICATION_CODE": 2,
                      "EXPIRED_VERIFICATION_CODE": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.VerifyVerificationEmailRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.VerifyVerificationEmailResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.VerifyVerificationEmailResponse?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE VerifyVerificationEmailRequest @ squareup/corporate_card/service/verify_verification_email.proto at 9:1
 */
export const VerifyVerificationEmailRequest = $root.lookupType('squareup.corporate_card.service.VerifyVerificationEmailRequest');
fixType(VerifyVerificationEmailRequest, {
  verificationCode: {
    required: true
  }
});
Builder.createAndAttachToType(VerifyVerificationEmailRequest);
/**
 * SOURCE VerifyVerificationEmailResponse @ squareup/corporate_card/service/verify_verification_email.proto at 16:1
 */
export const VerifyVerificationEmailResponse = $root.lookupType('squareup.corporate_card.service.VerifyVerificationEmailResponse');
fixType(VerifyVerificationEmailResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(VerifyVerificationEmailResponse);
/**
 * SOURCE Status @ squareup/corporate_card/service/verify_verification_email.proto at 17:5
 */
VerifyVerificationEmailResponse.Status = $root.lookupEnum('squareup.corporate_card.service.VerifyVerificationEmailResponse.Status').values;